import { ButtonBase, Typography } from '@material-ui/core'

import { LocalizedLink } from '../../routes/localizedRoutes'
import { Tenant } from '../../types/tenants'
import useStyles from './styles/TenantRow.styles'

interface TenantRowProps {
  data: Tenant
}
const TenantRow: React.FC<TenantRowProps> = ({ data }) => {
  const { name, tenantCode, displayTenantCode, tenantId } = data.basicDetails

  const classes = useStyles()

  return (
    <div className={classes.tableRowRoot}>
      <ButtonBase
        className={classes.tableRow}
        component={LocalizedLink}
        to={`/tenant/${tenantId}/${tenantCode}/details`}>
        <div className={classes.nameCell}>
          <Typography variant="h4">{name}</Typography>
        </div>
        <div>
          <Typography variant="body1" className={classes.code}>
            {displayTenantCode}
          </Typography>
        </div>
      </ButtonBase>
    </div>
  )
}
export default TenantRow
